// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H1Vc","colBig":"styles_colBig__3dGa9","colSmall":"styles_colSmall__1CUrc","shopifyNameWrapper":"styles_shopifyNameWrapper__1yVjI"};